export async function fetchMainCategories() {
  const response = await fetch('http://54.232.174.205:3001/categories');
  const data = await response.json();
  return data;
}

export async function fetchSubCategories(id) {
  const response = await fetch(`http://54.232.174.205:3001/categories/${id}`);
  const data = await response.json();
  return data;
}
